
var iDangerousSwiper = require('swiper');
var jQuery = require('jquery');
var Vue = require('vue');
var objectAssign = require('object-assign');

export default {
  label: 'Swiper',
  methods: {
    hideNavigation: function(force) {
      // We don't need to anything if it's not defined.
      if (!this.settings.hideButton && !force) {
        return;
      }

      var $el = jQuery(this.$el);

      // Hide previous el.
      if (typeof this.settings.prevButton === 'object' || !$el.find(this.settings.prevButton).length) {
        jQuery(this.settings.prevButton).hide();
      }
      else {
        $el.find(this.settings.prevButton).hide();
      }

      // Hide next el.
      // Object or not defined inside the container then just hide the el.
      if (typeof this.settings.nextButton === 'object' || !$el.find(this.settings.nextButton).length) {
        jQuery(this.settings.nextButton).hide();
      }
      else {
        $el.find(this.settings.nextButton).hide();
      }
    }
  },
  mounted: function() {
    var $el = jQuery(this.$el);
    var shouldInit = $el.find('.' + this.settings.slideClass).length > 1
    this.hideNavigation(!shouldInit);
    this.swiper = shouldInit ? new iDangerousSwiper($el, this.settings) : null;
  },
  settings: {},
  computed: {
    settings: function() {
      return objectAssign(
        {},
        this.$options.defaultSettings,
        this.$options.settings
      );
    },
  },
  defaultSettings: {
    "direction": "horizontal",
    "loop": true,
    "autoHeight": true,
    "pagination": ".swiper-pagination",
    "nextButton": ".swiper-button-next",
    "prevButton": ".swiper-button-prev",
    "hideButton": false,
    "slidesPerView": 1,
    "paginationClickable": true,
    "autoplay": 6000,
    "touchEventsTarget": "container",
    "initialSlide": 0,
    "speed": 300,
    "autoplayDisableOnInteraction": true,
    "autoplayStopOnLast": false,
    "iOSEdgeSwipeDetection": false,
    "iOSEdgeSwipeThreshold": 20,
    "freeMode": false,
    "freeModeMomentum": true,
    "freeModeMomentumRatio": 1,
    "freeModeMomentumBounce": true,
    "freeModeMomentumBounceRatio": 1,
    "freeModeMomentumVelocityRatio": 1,
    "freeModeSticky": false,
    "freeModeMinimumVelocity": 0.02,
    "setWrapperSize": false,
    "virtualTranslate": false,
    "effect": "slide",
    "coverflow": {
      "rotate": 50,
      "stretch": 0,
      "depth": 100,
      "modifier": 1,
      "slideShadows": true
    },
    "flip": {
      "slideShadows": true,
      "limitRotation": true
    },
    "cube": {
      "slideShadows": true,
      "shadow": true,
      "shadowOffset": 20,
      "shadowScale": 0.94
    },
    "fade": {
      "crossFade": false
    },
    "parallax": false,
    "zoom": false,
    "zoomMax": 3,
    "zoomMin": 1,
    "zoomToggle": true,
    "scrollbar": null,
    "scrollbarHide": true,
    "scrollbarDraggable": false,
    "scrollbarSnapOnRelease": false,
    "keyboardControl": false,
    "mousewheelControl": false,
    "mousewheelReleaseOnEdges": false,
    "mousewheelInvert": false,
    "mousewheelForceToAxis": false,
    "mousewheelSensitivity": 1,
    "mousewheelEventsTarged": "container",
    "hashnav": false,
    "hashnavWatchState": false,
    "history": false,
    "replaceState": false,
    "spaceBetween": 0,
    "slidesPerColumn": 1,
    "slidesPerColumnFill": "column",
    "slidesPerGroup": 1,
    "centeredSlides": false,
    "slidesOffsetBefore": 0,
    "slidesOffsetAfter": 0,
    "roundLengths": false,
    "touchRatio": 1,
    "touchAngle": 45,
    "simulateTouch": true,
    "shortSwipes": true,
    "longSwipes": true,
    "longSwipesRatio": 0.5,
    "longSwipesMs": 300,
    "followFinger": true,
    "onlyExternal": false,
    "threshold": 0,
    "touchMoveStopPropagation": true,
    "touchReleaseOnEdges": false,
    "uniqueNavElements": true,
    "paginationElement": "span",
    "paginationHide": false,
    "paginationBulletRender": null,
    "paginationProgressRender": null,
    "paginationFractionRender": null,
    "paginationCustomRender": null,
    "paginationType": "bullets",
    "resistance": true,
    "resistanceRatio": 0.85,
    "watchSlidesProgress": false,
    "watchSlidesVisibility": false,
    "grabCursor": false,
    "preventClicks": true,
    "preventClicksPropagation": true,
    "slideToClickedSlide": false,
    "lazyLoading": false,
    "lazyLoadingInPrevNext": false,
    "lazyLoadingInPrevNextAmount": 1,
    "lazyLoadingOnTransitionStart": false,
    "preloadImages": true,
    "updateOnImagesReady": true,
    "loopAdditionalSlides": 0,
    "loopedSlides": null,
    "controlInverse": false,
    "controlBy": "slide",
    "normalizeSlideIndex": true,
    "allowSwipeToPrev": true,
    "allowSwipeToNext": true,
    "swipeHandler": null,
    "noSwiping": true,
    "noSwipingClass": "swiper-no-swiping",
    "passiveListeners": true,
    "containerModifierClass": "swiper-container-",
    "slideClass": "swiper-slide",
    "slideActiveClass": "swiper-slide-active",
    "slideDuplicateActiveClass": "swiper-slide-duplicate-active",
    "slideVisibleClass": "swiper-slide-visible",
    "slideDuplicateClass": "swiper-slide-duplicate",
    "slideNextClass": "swiper-slide-next",
    "slideDuplicateNextClass": "swiper-slide-duplicate-next",
    "slidePrevClass": "swiper-slide-prev",
    "slideDuplicatePrevClass": "swiper-slide-duplicate-prev",
    "wrapperClass": "swiper-wrapper",
    "bulletClass": "swiper-pagination-bullet",
    "bulletActiveClass": "swiper-pagination-bullet-active",
    "buttonDisabledClass": "swiper-button-disabled",
    "paginationCurrentClass": "swiper-pagination-current",
    "paginationTotalClass": "swiper-pagination-total",
    "paginationHiddenClass": "swiper-pagination-hidden",
    "paginationProgressbarClass": "swiper-pagination-progressbar",
    "paginationClickableClass": "swiper-pagination-clickable",
    "paginationModifierClass": "swiper-pagination-",
    "lazyLoadingClass": "swiper-lazy",
    "lazyStatusLoadingClass": "swiper-lazy-loading",
    "lazyStatusLoadedClass": "swiper-lazy-loaded",
    "lazyPreloaderClass": "swiper-lazy-preloader",
    "notificationClass": "swiper-notification",
    "preloaderClass": "preloader",
    "zoomContainerClass": "swiper-zoom-container",
    "observer": false,
    "observeParents": false,
    "a11y": false,
    "prevSlideMessage": "Previous slide",
    "nextSlideMessage": "Next slide",
    "firstSlideMessage": "This is the first slide",
    "lastSlideMessage": "This is the last slide",
    "paginationBulletMessage": "Go to slide {{index}}",
    "runCallbacksOnInit": true
  },
};



// WEBPACK FOOTER //
// ./app/components/organisms/swiper/swiper.amd.vue